// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__Jd3FJ","anima_svg":"Loader_anima_svg__aSh-U"};